<template lang="pug">
  router-view(
    v-bind:sideNavData="sideNavData"
  )
</template>
<script>
import {mapState} from "vuex";

export default {
  name: "AnalyticsPage",
  // data: () => ({}),
  data() {
    return {
      sideNavData: {
        links: [
          {
            path: "/pages/analytics",
            text: "Аналитика"
          }
        ]
      }
    };
  }

};
</script>
<style lang="scss" scoped></style>
